<!-- eslint-disable max-len, vue/no-confusing-v-for-v-if -->
<template>
  <div id="vp-container">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header canvas">
      <b-row>
        <b-col md="8">
          <div class="d-flex">
            <img
              class="back-to-list-apps"
              src="@/assets/icon/arrow-left.svg"
              @click="$router.push('/canvas')"
            >
            <div class="auto__label-head ellipsis">
              {{ name_canvas }} <br>
              <span>{{ dataDetail ? dataDetail.id : '' }}</span>
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--8"/>
          <span
            class="btn-save-action-canvas pull-right m__r--5"
            @click="saveCanvas">
            <img
              src="@/assets/icon/check-blue.png"
              width="17" >
            Save
          </span>
        </b-col>
      </b-row>

      <b-row id="vp-container-tab">
        <b-col
          :class="{'studio-page-tab-active' : modeCanvas === 'list'}"
          class="studio-page-tab centered p__t--24"
          @click="selectTab('list')">
          <h4>WIDGET LIST</h4>
          <div
            v-if="modeCanvas === 'list'"
            class="underline-data"/>
        </b-col>
        <b-col
          :class="{'studio-page-tab-active' : modeCanvas === 'config'}"
          class="studio-page-tab centered p__t--24"
          @click="selectTab('config')">
          <h4>CONFIG</h4>
          <div
            v-if="modeCanvas === 'config'"
            class="underline-data"/>
        </b-col>
      </b-row>
    </div>

    <div class="container-widget">
      <!-- Content Tab List -->
      <div v-if="modeCanvas === 'list' && dataDetail">
        <draggable v-model="dataDetail.widgets">
          <transition-group>
            <div
              v-for="(data, index) in dataDetail.widgets"
              :key="index + 0"
              class="list-column-ui canvas-item">
              <b-row>
                <b-col
                  md="1"
                  class="d-flex align-items-center justify-content-center cursor-pointer">
                  <img
                    v-if="data.type=='line_chart'"
                    src="@/assets/icon/canvas/linechart.png"
                    width="30" >
                  <img
                    v-if="data.type=='pie_chart'"
                    src="@/assets/icon/canvas/piechart.png"
                    width="30" >
                  <img
                    v-if="data.type=='bar_chart'"
                    src="@/assets/icon/canvas/barchart.png"
                    width="30" >
                  <img
                    v-if="data.type=='text'"
                    src="@/assets/icon/canvas/text.png"
                    width="30" >
                  <img
                    v-if="data.type=='table'"
                    src="@/assets/icon/canvas/table.png"
                    width="30" >
                  <img
                    v-if="data.type=='map'"
                    src="@/assets/icon/canvas/map.png"
                    width="30" >
                  <img
                    v-if="data.type=='progress_bar'"
                    src="@/assets/icon/canvas/progress_bar.png"
                    width="30" >
                </b-col>
                <b-col md="10">
                  <div class="canvas--label-widget">{{ data.name }}</div>
                  <div class="canvas--label-widget-data">
                    {{ data.type === 'table' ? data.form_ui_name : data.form_data_name }}
                  </div>
                </b-col>
                <b-col
                  md="1"
                  class="d-flex align-items-center justify-content-center">
                  <i
                    class="fa fa-2x fa-pencil cursor-pointer m__r--8"
                    @click="openModalWidget(data, index)"
                  />
                  <i
                    class="fa fa-2x fa-trash cursor-pointer"
                    @click="deleteWidget(index)"
                  />
                </b-col>
              </b-row>
            </div>
          </transition-group>
        </draggable>
        <div
          id="widget-add"
          class="add-canvas-item"
          @click="openModalWidget(null)">
          <div
            id="widgetAdd"
            class="icon-plus">
            +
          </div>
        </div>
      </div>

      <!-- Content Tab Config -->
      <div v-if="modeCanvas === 'config' && dataDetail">
        <!-- Display Timeframe -->
        <div class="canvas-config mb-4">
          <h4>Display Timeframe</h4>
          <label>If active, the timeframe will be filterable from the dashboard</label>
          <j-toggle
            v-model="isShowTimeframe"
            :disabled="!dataDetail.widgets || dataDetail.widgets.length === 0"
            class="toggle-config"
          />
        </div>

        <!-- Search Option List -->
        <div class="canvas-config">
          <div>Search Options List</div>

          <draggable v-model="dataDetail.search_options_list">
            <transition-group class="row-drag">
              <div
                v-for="(data, index) in dataDetail.search_options_list"
                :key="index"
                class="list-column-ui col-drag-12">
                <b-row>
                  <b-col
                    md="1"
                    class="d-flex align-items-center justify-content-center cursor-pointer p__l--1 p__r--1">
                    <i class="fa fa-2x fa-ellipsis-v"/>
                  </b-col>
                  <b-col
                    md="4"
                    class="p__l--1 p__r--1">
                    <h4 style="margin-bottom: 0px !important">
                      {{ data.name }}
                    </h4>
                    <span>
                      {{ data.type }}
                    </span>
                  </b-col>
                  <b-col
                    md="4"
                    class="d-flex align-items-center p__l--5 p__r--1">
                    <span>
                      {{ data.field_data_key }}
                    </span>
                  </b-col>
                  <b-col
                    md="2"
                    class="d-flex align-items-center justify-content-end cursor-pointer p__l--1 p__r--1">
                    <i
                      class="fa fa-lg fa-pencil m__r--8"
                      @click="openModalEditField(data, index)"
                    />
                    <i
                      class="fa fa-lg fa-trash"
                      @click="deleteField(index)"
                    />
                  </b-col>
                </b-row>
              </div>
            </transition-group>
          </draggable>

          <button
            class="btn btn-add-column"
            @click="openModalEditField(null, null)">
            + Add field
          </button>
        </div>
      </div>
    </div>

    <b-modal
      ref="modalForm"
      class="mod-form modal-form-canvas"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div>
        <j-widget-form
          v-if="isOpen"
          :field-detail="selectedField"
          @close-modal="closeModalEditField"
          @submit-mode="submitField"
        />
      </div>
    </b-modal>

    <b-popover
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      placement="left">
      <div
        class="add-automation"
        @click="renameCanvas">Rename</div>
      <div
        class="add-automation"
        @click="removeCanvas">Delete</div>
    </b-popover>

    <b-modal
      id="modal-form"
      ref="modalFormField"
      class="mod-form modal-create-view"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div>
        <j-column-edit
          v-if="isOpenField"
          :field-detail="selectedField"
          :variable-options="variableOptionsFilter"
          :is-search="true"
          :field-ui-key="dataDetail.search_options_list"
          @close-modal="closeModalEditField"
          @submit-mode="submitFieldSearch"
        />
      </div>
    </b-modal>

    <b-modal
      ref="updateNameModal"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>

      <b-form-group :class="{'error-input' : $v.name_canvas.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.name_canvas.$model"
          :max-length="255"
          placeholder="Name"/>
      </b-form-group>

      <div class="float-right m__t--20">
        <b-button
          class="btn m__r--5"
          @click="closeRenameCanvas">
          Cancel
        </b-button>
        <b-button
          class="btn blue"
          @click="saveCanvas">
          Update
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-console */
import draggable from 'vuedraggable';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

import jWidgetForm from '@/views/canvas/widget/jWidgetForm';
import jColumnEdit from '@/views/experience-manager/menu/jColumnEdit';

export default {
  name: 'JCanvasDetail',
  components: {
    draggable,
    jWidgetForm,
    jColumnEdit,
  },
  validations: {
    dataDetail: { },
    name_canvas: {
      required,
    },
  },
  data() {
    return {
      name_canvas: '',
      isOpen: false,
      isOpenField: false,
      selectedField: null,
      selectedIndexField: null,
      configPopoverShow: false,
      modeCanvas: 'list',
      isDetail: false,
      dataDetail: null,
      isShowTimeframe: false,
      variableOptions: [],
      isError: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    variableOptionsFilter() {
      return this.variableOptions.filter(f => !f.is_delete);
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'dataDetail.widgets': function (val) {
      if (val.length === 0) this.isShowTimeframe = false;
    },
  },
  created() {
    if (this.$route.params.canvasId) {
      this.isDetail = true;

      const dataFilter = {
        id: [this.$route.params.canvasId],
      };
      const param = {
        limit: 10,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailCanvas(param).then((data) => {
        this.dataDetail = data.data.data.find(e => e.id === this.$route.params.canvasId);
        this.isShowTimeframe = !this.dataDetail.widgets || this.dataDetail.widgets.length === 0 ? false : (this.dataDetail.is_show_timeframe || false);
        this.name_canvas = this.dataDetail.name;

        this.dataDetail.widgets.forEach((e) => {
          this.getFormData(e.form_data_id);
        });
      });
    }
  },
  methods: {
    ...mapActions('jStoreCanvas', ['createCanvas', 'getDetailCanvas', 'deleteCanvas']),
    ...mapActions('jStoreForm', ['findFormData']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    getFormData(id) {
      const reqData = {
        form_data_id: id,
      };
      this.findFormData(reqData).then((res) => {
        const formData = res.data || null;
        const dataColumn = formData && formData.columns ? Object.values(formData.columns) : [];

        dataColumn.forEach((column) => {
          const existData = this.variableOptions.find(f => f.id === column.name);
          if (column.type !== '[]attachment' && !existData) {
            this.variableOptions.push({
              id: column.name,
              label: column.name,
              text: column.name,
              form_data_id: id,
              type: column.type,
              is_delete: false,
            });
          }
        });
      });
    },

    selectTab(data) {
      this.modeCanvas = data;
    },

    renameCanvas() {
      this.$refs.updateNameModal.show();
      this.configPopoverShow = false;
    },

    closeRenameCanvas() {
      this.$refs.updateNameModal.hide();
      this.name_canvas = this.dataDetail.name;
    },

    saveCanvas() {
      this.dataDetail.name = this.name_canvas;
      this.dataDetail.is_show_timeframe = this.isShowTimeframe;
      const data = this.dataDetail;
      this.createCanvas(data);
      this.$refs.updateNameModal.hide();
    },

    submitField(mode, params) {
      if (mode === 'add') {
        this.dataDetail.widgets.push(params);
      } else {
        this.dataDetail.widgets[this.selectedIndexField] = params;
      }
      this.getFormData(params.form_data_id);
    },

    submitFieldSearch(mode, params) {
      const findKeySame = this.dataDetail.search_options_list ?
        this.dataDetail.search_options_list.find(e => e.field_data_key === params.field_data_key) :
        null;
      const param = {
        type: params.type,
        name: params.name,
        config: params.config,
        field_data_key: params.field_data_key,
      };
      if (mode === 'add') {
        if (!findKeySame) {
          this.isError = false;
          if (this.dataDetail.search_options_list) {
            this.dataDetail.search_options_list.push(param);
          } else {
            this.dataDetail.search_options_list = [param];
          }
        } else {
          this.isError = true;
          this.toggleProblem('Variable cannot be the same!');
          setTimeout(() => {
            this.isError = false;
          }, 500);
        }
      } else {
        // eslint-disable-next-line
        if (this.selectedField.field_data_key === params.field_data_key) {
          this.isError = false;
          this.dataDetail.search_options_list[this.selectedIndexField] = param;
        } else {
          // eslint-disable-next-line
          if (!findKeySame) {
            this.isError = false;
            this.dataDetail.search_options_list[this.selectedIndexField] = param;
          } else {
            this.isError = true;
            this.toggleProblem('Variable cannot be the same!');
            setTimeout(() => {
              this.isError = false;
            }, 500);
          }
        }
      }
    },

    removeCanvas() {
      const text = 'Are you sure to delete this data?';

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.canvasId,
          };
          this.deleteCanvas(param);
        }
      });
    },

    openModalWidget(data, index) {
      this.selectedField = data;
      this.selectedIndexField = index;
      this.isOpen = true;
      this.$refs.modalForm.show();
    },

    deleteWidget(index) {
      const dataWidget = this.dataDetail.widgets[index];
      this.variableOptions.forEach((e, indexVar) => {
        if (e.form_data_id === dataWidget.form_data_id) {
          this.variableOptions[indexVar].is_delete = true;
        }
      });
      this.dataDetail.widgets.splice(index, 1);
    },

    deleteField(index) {
      this.dataDetail.search_options_list.splice(index, 1);
    },

    openModalEditField(data, index) {
      this.selectedField = data;
      this.selectedIndexField = index;
      this.isOpenField = true;
      this.$refs.modalFormField.show();
    },

    closeModalEditField() {
      if (!this.isError) {
        this.$refs.modalForm.hide();
        this.$refs.modalFormField.hide();
        this.isOpen = false;
        this.isOpenField = false;
      }
    },
  },
};
</script>

<style lang="scss">
  .modal-form-canvas .modal-dialog {
    max-width: 1000px !important;
  }

  #vp-container {
    .studio-page-header.canvas {
      height: 120px;
    }
  }

  #vp-container-tab {
    .col {
      flex-basis: content;
      flex-grow: 0;
    }
  }

  .container-widget {
    padding: 150px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/canvas/jCanvasDetail.vue